import { Observable } from 'rxjs';
import {
  ExtractionFileUploadResponse,
  SpecimenForExtraction,
  ExtractionAssociation,
  AssociateExtractionsResponse
} from '../../../model/associate-extraction/file/extraction-file-upload.model';

/**
 * Repository interface for extraction file operations.
 *
 * Following Clean Architecture, this is the port (interface) that the domain layer
 * defines for file upload operations. The actual implementation lives in infrastructure.
 *
 * HU24 - Cargar Datos de Extracción mediante archivo
 */
export abstract class ExtractionFileRepository {
  /**
   * Uploads an extraction file for processing.
   *
   * @param file - The Excel file to upload
   * @returns Observable with the processing result
   */
  abstract uploadExtractionFile(
    file: File
  ): Observable<ExtractionFileUploadResponse>;

  /**
   * Gets specimens with PENDING_EXTRACTION status.
   * These specimens are available for extraction association.
   *
   * @returns Observable with the list of specimens
   */
  abstract getSpecimensPendingExtraction(): Observable<SpecimenForExtraction[]>;

  /**
   * Associates LG codes with extractions.
   * Updates extraction status to IN_PROGRESS.
   *
   * @param associations - Array of extraction-LG pairs
   * @returns Observable with the association result
   */
  abstract associateExtractions(
    associations: ExtractionAssociation[]
  ): Observable<AssociateExtractionsResponse>;
}
